// @flow
import styled from 'styled-components';
import { mercuryGrey, daveGrey, cleanWhite, jetBlack } from '../../../colors';
import { shadow2 } from '../../../shadows';
/*::
import type { Node } from 'react';

export type PrimaryButtonThemeType = {|
  Button: * => Node,
  Hover: * => Node,
  SpinnerWrapper: * => Node,
|};
*/

var thm
/*: PrimaryButtonThemeType */
= {
  Button: styled.button.withConfig({
    displayName: "theme__Button",
    componentId: "sc-1ls5d2j-0"
  })(["display:inline-block;text-decoration:none;position:relative;height:4rem;overflow:hidden;padding:0;border:none;border-radius:2.5rem;background:", ";color:", ";cursor:", ";font-size:2rem;font-weight:200;&:hover{", "}"], function (pr) {
    return pr.disabled ? mercuryGrey() : jetBlack();
  }, function (pr) {
    return pr.disabled ? daveGrey() : cleanWhite();
  }, function (pr) {
    return pr.disabled || pr.loading ? 'not-allowed' : 'pointer';
  }, function (pr) {
    return pr.disabled || pr.loading ? null : shadow2;
  }),
  Hover: styled.span.withConfig({
    displayName: "theme__Hover",
    componentId: "sc-1ls5d2j-1"
  })(["height:100%;box-sizing:border-box;text-align:center;padding:0 4rem;display:flex;align-items:center;justify-content:center;", " &:hover{", ";}"], function (pr) {
    return pr.loading && !pr.disabled ? "background: " + jetBlack(0.15) + ";" : null;
  }, function (pr) {
    return pr.disabled ? null : "background: " + jetBlack(0.15) + ";";
  }),
  SpinnerWrapper: styled.div.withConfig({
    displayName: "theme__SpinnerWrapper",
    componentId: "sc-1ls5d2j-2"
  })(["box-sizing:border-box;position:absolute;right:1.4rem;top:50%;width:2rem;height:2rem;transform:translateY(-50%);"])
};
export default thm;